import Vue from 'vue'
import PortalVue from 'portal-vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue'
//import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import { VueEditor } from "vue2-editor";

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
//import 'tiptap-vuetify/dist/main.css'

import VueMeta from 'vue-meta'

Vue.config.productionTip = false
Vue.use(PortalVue)




const vuetify = new Vuetify({
  treeShake: true,
  theme: {
    themes: {
      light: {
        primary: '#560354',
        secondary: '#e7c6c8',
        accent: '#333',
        error: '#b71c1c',
      },
      dark: {
        primary: '#560354',
        secondary: '#e7c6c8',
        accent: '#333',
        error: '#b71c1c',
      },
    },
  },
})

/*Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'md'
})*/


InertiaProgress.init()

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} - BacktoWorkConnect.ie` : 'BacktoWorkConnect.ie',
  setup({ el, app, props, plugin }) {
    Vue.use(plugin)
    Vue.use(Vuetify);
    Vue.use(VueMeta, {
      // optional pluginOptions
      refreshOnceOnNavigation: true
    });
    
    new Vue( { vuetify: vuetify,render: h => h(app, props) })
      .$mount(el)
  },
})
